import React from "react";
import { TableProps } from "..";
import theme from "@/constants/theme";

interface TableHeadProps {
  columns: TableProps["columns"];
  components: TableProps["components"];
}

const TableHead: React.FC<TableHeadProps> = ({ columns, components }) => {
  const ActionComponent = components?.Action;

  return (
    <thead style={styles.thead}>
      <tr>
        {columns.map((column, index) => (
          <th key={index} style={styles.th}>
            {column.title}
          </th>
        ))}
        {ActionComponent && <th style={styles.th} />}
      </tr>
    </thead>
  );
};

const styles: Record<string, React.CSSProperties> = {
  th: {
    color: theme.colors.text.caption,
    padding: "10px",
    textAlign: "left",
    opacity: 0.5,
  },
};

export default TableHead;
